<template>
  <div v-if="visible" class="notification is-warning cache-stale-notice">
    <i class="fal fa-hourglass-half"></i>
    ບັນທຶກແລ້ວ ແຕ່<strong>ຍັງບໍ່ທັນມີຜົນທຸກບ່ອນ</strong> —
    <!--
      ແຕ່ລະໜ້າບອກຜົນກະທົບຂອງຕົນເອງ (ບິນ / ການຍິງ / ຄ່າມື້ຕີກັບ) ເພາະຄຳວ່າ “ຄ່າເກົ່າ”
      ລອຍໆ ບໍ່ໄດ້ບອກພະນັກງານວ່າຕ້ອງລະວັງຫຍັງ.
    -->
    <slot>ບາງເຄື່ອງອາດຍັງໃຊ້ຄ່າເກົ່າ</slot>
    ອີກປະມານ {{ minutes }} ນາທີ. ຖ້າກາຍນັ້ນແລ້ວຍັງບໍ່ປ່ຽນ ກະລຸນາແຈ້ງທີມ IT.
  </div>
</template>

<script>
/**
 * Shown when a save COMMITTED but the backend could not invalidate its shared cache.
 *
 * The distinction matters and is easy to lose: the row is stored, so "ບັນທຶກສຳເລັດ" is not a lie
 * — but readers (printed bills, tracking, parcel scans) can keep using the previous value until
 * the cache expires. An operator who sees only the success toast will change a setting, watch a
 * bill print the old value, and reasonably conclude the save did not work.
 *
 * Shared by every screen that edits a cached config map — returning-rule settings, the branch
 * DC-code prefix override and the branch inbound-destination change — so the wording and the
 * quoted window stay in step. All three backends signal it the same way: a `cache_stale: true`
 * field on the mutation response.
 */
export default {
  name: 'CacheStaleNotice',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * Must match the services' CACHE_TTL (300s). A number here rather than baked into the
     * sentence so a TTL change is a one-line edit, not a hunt through Lao copy.
     */
    minutes: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style lang="scss" scoped>
.cache-stale-notice {
  margin-top: 10px;

  i {
    margin-right: 6px;
  }
}
</style>
